export default "__VITE_ASSET__dd734020__"